var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#1870A1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.015 10.169C12.0887 10.169 11.2716 10.6103 10.7378 11.2861L5.78654 8.75407C5.85136 8.51231 5.89795 8.26252 5.89795 7.99963C5.89795 7.71344 5.84262 7.444 5.76541 7.18182L10.6948 4.66143C11.2257 5.36782 12.0639 5.82953 13.0157 5.82953C14.628 5.82953 15.9323 4.52527 15.9323 2.91441C15.9323 1.305 14.628 0 13.0157 0C11.4071 0 10.1014 1.305 10.1014 2.91438C10.1014 3.17801 10.148 3.42851 10.2135 3.67101L5.26296 6.20308C4.72843 5.52656 3.90989 5.0838 2.98213 5.0838C1.37126 5.0838 0.067749 6.38951 0.067749 7.99963C0.067749 9.60975 1.37129 10.9147 2.98213 10.9147C3.93538 10.9147 4.77286 10.4516 5.3059 9.74449L10.2331 12.2649C10.1559 12.5263 10.0999 12.798 10.0999 13.0849C10.0999 14.695 11.4056 16 13.0142 16C14.6266 16 15.9308 14.695 15.9308 13.0849C15.9316 11.4733 14.6273 10.169 13.015 10.169Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.073602a2.svg";
export { ForwardRef as ReactComponent };